import { render, staticRenderFns } from "./LabelTypeSelection.vue?vue&type=template&id=4e3e286c&scoped=true"
import script from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabelTypeSelection.vue?vue&type=style&index=0&id=4e3e286c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e286c",
  null
  
)

export default component.exports